import Logo from '../../assets/branding/colour-logo.png';

const ErrorScreen = ({ children }) => {
  return (
    <div className="error-screen">
      <div className="error-screen__container">
        <img src={Logo} alt="golingo Parrot" title="golingo Parrot" />
        <h2 className="error-screen__title">Oh no!</h2>
        <p>
          It looks like something went wrong! Click the refresh button below to
          try again.
        </p>
        <p>If the error continues please send the below report to our team</p>
        <button
          className="button"
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh
        </button>
        <div className="error-container">
          <h4>Error report:</h4>
          <p className="error-report">{children}</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorScreen;
